




























import Vue from 'vue';
import RidesTable from '@/components/Employees/RidesTable.vue';

export default Vue.extend({
    props: {
        userId: {
            required: true,
            type: Number,
        },
        dateRange: {
            required: true,
            type: Array,
        },
    },
    components: {
        RidesTable,
    },
    data() {
        return {
            selectedUserId: 0,
            sharedRidesDialog: false,
            loading: false,
            headers: [
                { text: 'Name', value: 'fullName', width: 300 },
                { text: 'Email', value: 'email' },
                { text: 'Phone', value: 'formattedPhone' },
                { text: 'Shared Rides', value: 'sharedRides', align: 'center' },
            ],
            data: [] as Array<object>,
        };
    },
    methods: {
        onSharedRidesClick(item: any) {
            this.selectedUserId = item.userId;
            this.sharedRidesDialog = true;
        },
        getUserSharedRides() {
            if (this.dateRange.length === 2 && this.userId) {
                this.data = [];
                if (this.userId > 0) {
                    this.loading = true;
                    this.$hipApi
                        .getUserSharedRides(this.userId, this.dateRange[0] as string, this.dateRange[1] as string)
                        .then((res: any) => {
                            this.data = this.groupBy(res, 'userId');
                        })
                        .catch((err) => {
                            this.$notifier.showError(err?.error?.message || err?.message || err);
                        })
                        .finally(() => {
                            this.loading = false;
                        });
                }
            }
        },
        groupBy(xs: any, key: any): Array<object> {
            const reduced = xs.reduce((rv: any, x: any) => {
                (rv[x[key]] = rv[x[key]] || []).push(x);
                return rv;
            }, {});
            const resultArray: Array<object> = [];
            Object.keys(reduced).forEach((key: any) => {
                reduced[key][0].sharedRides = reduced[key].length;
                resultArray.push(reduced[key][0]);
            });
            return resultArray;
        },
    },
    watch: {
        userId(newVal) {
            this.getUserSharedRides();
        },
        dateRange() {
            this.getUserSharedRides();
        },
    },
    created() {
        this.getUserSharedRides();
    },
});
